
const routerArr = [
    // 培训任务详情定制添加表单提示填写-定位在底部 2022-01-11
    {
        path: '/profile',
        name: 'profile',
        meta: { title:'我的资料' , login: false  },
        component: () => import(/* webpackChunkName: 'profile' */ './page/profile.vue'),
    }
   
]
export default routerArr
